var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDataAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 44H12C7.58 44 4 40.42 4 36V12C4 7.58 7.58 4 12 4H36C40.42 4 44 7.58 44 12V36C44 40.42 40.42 44 36 44ZM12 8C9.8 8 8 9.8 8 12V36C8 38.2 9.8 40 12 40H36C38.2 40 40 38.2 40 36V12C40 9.8 38.2 8 36 8H12ZM12.76 30.5C12.24 30.5 11.74 30.3 11.34 29.92C10.56 29.14 10.56 27.88 11.34 27.1L18.1 20.34C18.88 19.56 20.14 19.56 20.92 20.34L24 23.42L29.34 18.08C30.12 17.3 31.38 17.3 32.16 18.08L36.66 22.58C37.44 23.36 37.44 24.62 36.66 25.4C35.88 26.18 34.62 26.18 33.84 25.4L30.76 22.32L25.42 27.66C24.64 28.44 23.38 28.44 22.6 27.66L19.52 24.58L14.18 29.92C13.78 30.32 13.28 30.5 12.76 30.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataAnalytics);
export default __webpack_public_path__ + "static/media/icon-data-analytics.3b830216.svg";
export { ForwardRef as ReactComponent };